<template>
  <div class="doge-shell">
    <header class="doge-top green"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title green-text">提现地址</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="doge-card address-card">
        <h2>系统绑定钱包</h2>
        <div class="bound-row"><span>{{ mask(getWalletAddress) || '请先连接钱包' }}</span><b v-if="getWalletAddress">✓</b></div>
        <p class="hint">提现只能提现到当前连接并绑定的钱包地址，不使用本地添加地址。</p>
        <button class="green-btn" @click="confirm">{{ getWalletAddress ? '去提现' : '连接钱包' }}</button>
      </section>
    </main>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'withdrawAddress',
  computed: { ...mapGetters(['getWalletAddress']) },
  methods: {
    async confirm() {
      if (!this.getWalletAddress) {
        if (!window.ethereum) return this.msg('请先安装钱包');
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        if (accounts && accounts[0]) await this.$store.dispatch('updateWalletAddress', accounts[0]);
      }
      if (!this.getWalletAddress) return this.msg('请先连接钱包');
      await this.$axios.post('/api/wallet/address/upload', { address: this.getWalletAddress });
      this.$router.push({ name: 'withdraw' });
    },
    mask(s) { s = (s || '').toString(); return s.length > 18 ? s.slice(0, 10) + '...' + s.slice(-8) : s; },
    msg(t) { this.$messageDialog ? this.$messageDialog.alert(t, '提示', 'info') : alert(t); }
  }
};
</script>
<style scoped>.green{background:#050506}.green-text{color:var(--doge-green)!important}.address-card{min-height:240px}.address-card h2{font-size:18px;margin:10px 0 14px;color:#211507}.bound-row{min-height:52px;border-radius:14px;background:#fff8e8;border:1px solid #ead9b6;display:flex;align-items:center;justify-content:space-between;padding:0 14px;margin-bottom:12px;color:#211507;word-break:break-all}.bound-row b{color:var(--doge-green);font-size:22px}.hint{color:#8b806d;line-height:1.7;margin:14px 0 22px}.green-btn{width:100%;height:50px;border:0;border-radius:999px;background:var(--doge-green);color:#042017;font-weight:800;font-size:16px;margin-top:12px}</style>
